angular.module 'zc.masterApi'

.factory 'MasterAgency', ($q, Api) ->
  class MasterAgency
    @all: ->
      Api.get '/api/master/agencies'
      .then (res) ->
        if res.data.success
          res.data.agencies
        else
          $q.reject res

    @get: (params) ->
      Api.get "/api/master/agencies/#{params.id}", {}, cache: false
      .then (res) ->
        if res.data.success
          res.data.agency
        else
          $q.reject res

    @update: (params) ->
      Api.patch "/api/master/agencies/#{params.id}", params, cache: false

    @create: (params) ->
      Api.post "/api/master/agencies", params, cache: false



// WEBPACK FOOTER //
// ./src/master_admin_modules/master_api/api/master_agency.service.js.coffee